<!-- src/views/Home.vue -->
<template>
  <div>
    <h2>Home Page</h2>
    <p>Welcome to the homepage.</p>
  </div>
</template>